import React from "react";
import Button from "../../../../components/Button/Button";
import Icon5 from "../../../../icons/Icon5/Icon5";
import "./style.scss";

import vector from "../../../../../static/img/vector.svg";
import vector1 from "../../../../../static/img/vector-1.svg";
import vector2 from "../../../../../static/img/vector-2.svg";

const ActionSectionSubsection = ({t}) => {
  return (
    <section className="cta-card" aria-labelledby="cta-title">
      <header className="cta-head">
        <h2 id="cta-title" className="cta-title">{t('Start Your Collecting Journey')}</h2>
        <p className="cta-sub">
          {t('Easily upload, trade, and manage your Hockey & Pokémon card collection — all in one platform.')}
        </p>
      </header>

      <ul className="cta-steps" role="list">
        <li className="cta-step">
          <span className="cta-icon" aria-hidden="true">
            <img src={vector} alt="" />
          </span>
          <h3 className="cta-step-title">{t('Add Your Cards')}</h3>
          <p className="cta-step-text">
           {t('Snap a pic or scan, add them to your folio, and get ready to trade.')}
          </p>
        </li>

        <li className="cta-step">
          <span className="cta-icon" aria-hidden="true">
            <img src={vector1} alt="" />
          </span>
          <h3 className="cta-step-title">{t('Explore & Trade')}</h3>
          <p className="cta-step-text">
            {t('Browse cards from other collectors and set up secure trades instantly.')}
          </p>
        </li>

        <li className="cta-step">
          <span className="cta-icon" aria-hidden="true">
            <img src={vector2} alt="" />
          </span>
          <h3 className="cta-step-title">{t('Manage & Sell')}</h3>
          <p className="cta-step-text">
            {t('Monitor market trends, set prices, and sell when the moment is right.')}
          </p>
        </li>
      </ul>

      <div className="cta-actions">
        <Button
          className="cta-btn"
          icon
          override={<Icon5 className="cta-btn-icon" />}
          size="default"
          state="default"
          text={t('Buy & Collect')}
          type="secondary"
        />
        <Button
          className="cta-btn"
          icon
          override={<Icon5 className="cta-btn-icon" />}
          size="default"
          state="default"
          text={t('Follow Your Favorites')} 
          type="secondary"
        />
        <Button
          className="cta-btn"
          icon
          override={<Icon5 className="cta-btn-icon" />}
          size="default"
          state="default"
          text={t('Create Your Wishlist')}
          type="secondary"
        />
        <Button
          className="cta-btn"
          icon
          override={<Icon5 className="cta-btn-icon" />}
          size="default"
          state="default"
          text={t('Connect with Collectors')}
          type="secondary"
        />
      </div>
    </section>
  );
};

export default ActionSectionSubsection;


// import React from "react";
// import "./style.scss";

// /* tiny inline icons (so you don't depend on any lib here) */
// const Bolt = (props) => (
//   <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
//     <path fill="currentColor" d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
//   </svg>
// );
// const Grid = (props) => (
//   <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
//     <path fill="currentColor" d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z" />
//   </svg>
// );
// const Explore = (props) => (
//   <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
//     <path fill="currentColor" d="m10.5 13.5 3-3 6.7-6.7 1.5 1.5-6.7 6.7-3 3-1.6-.5.6-1zM10 4a6 6 0 1 1-4.24 1.76A5.97 5.97 0 0 1 10 4m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"/>
//   </svg>
// );
// const Bag = (props) => (
//   <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
//     <path fill="currentColor" d="M7 7V6a5 5 0 0 1 10 0v1h3v14H4V7h3zm2 0h6V6a3 3 0 0 0-6 0v1z"/>
//   </svg>
// );

// const CARDS = [
//   {
//     icon: Grid,
//     title: "Add Your Cards",
//     body:
//       "Snap a pic or scan, add them to your folio, and get ready to trade.",
//   },
//   {
//     icon: Explore,
//     title: "Explore & Trade",
//     body:
//       "Browse cards from other collectors and set up secure trades instantly.",
//   },
//   {
//     icon: Bag,
//     title: "Manage & Sell",
//     body:
//       "Monitor market trends, set prices, and sell when the moment is right.",
//   },
// ];

// const PILLS = [
//   "Buy & Collect",
//   "Follow Your Favorites",
//   "Create Your Wishlist",
//   "Connect with Collectors",
// ];

// const ActionSectionSubsection = () => {
//   return (
//     <div className="cta-panel">
//       <header className="cta-head">
//         <h2 className="cta-title">Start Your Collecting Journey</h2>
//         <p className="cta-sub">
//           Easily upload, trade, and profit from your hockey card collection — all in one platform.
//         </p>
//       </header>

//       <div className="cta-grid">
//         {CARDS.map(({ icon: Icon, title, body }) => (
//           <article className="cta-card" key={title}>
//             <span className="cta-icon">
//               <Icon className="i" />
//             </span>
//             <h3 className="cta-card__title">{title}</h3>
//             <p className="cta-card__body">{body}</p>
//           </article>
//         ))}
//       </div>

//       <div className="cta-pills" role="list">
//         {PILLS.map((label) => (
//           <button className="cta-pill" key={label} role="listitem">
//             <span className="bolt"><Bolt /></span>
//             {label}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ActionSectionSubsection;
